// ------------------------------------
// Constants
// ------------------------------------
export const LOCATION_GROUP_WINDOW = 'LOCATION_GROUP_WINDOW';

// ------------------------------------
// Actions
// ------------------------------------
export function locationGroupVisible (show = false, data = {}) {
  return {
    type    : LOCATION_GROUP_WINDOW,
    payload : {
      show, 
      data
    }
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
export function locationGroupWindowReducer (state = {show: false, data: {}}, action) {
    return action.type === LOCATION_GROUP_WINDOW
        ? action.payload
        : state
}


// WEBPACK FOOTER //
// ./src/store/locationGroup.js